import { Button, Modal, Alert, Row, Col } from "react-bootstrap";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../masters/GridMaster.css";
import { BsX } from "react-icons/bs";
import { AgGridReact } from "ag-grid-react";
import { useRef, useState, useEffect, useMemo, } from "react";
import GolbalSearch from "./GolbalSearch";
import { getActiveCustomers } from "../../services/customer-service";
import { getAllActiveLocations, getActiveLocationForDivision } from "../../services/location-master-service";
import { getItems } from "../../services/item-master-service";
import { sortByPropertyInAscending } from "../../utils/Utility";

const MultiValuePopUp = (props) => {

  let count = 1;
  let arr = props.masterName.split(":");
  let masterName = arr[0];
  const gridRef = useRef();
  const isProgrammaticSelect = useRef(false);
  const selectedDataRef = useRef([]);
  const [dataMethod, setDataMethod] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [parameters, setParams] = useState(null);
  const [ready, setReady] = useState(false);
  const [filteredCol, setFilteredCol] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [data, setData] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [pageSize] = useState(3);

  const fetchData = async (param) => {
    let tmpResult;
    if (masterName === "Customer Master") {
      let allResults = [];
      let lastEvaluatedKey = null;
      let batchCount = 0;
      const BATCH_SIZE = 2000;
      //tmpResult = await getActiveCustomers();
      do {
        batchCount++;
        console.log(`Fetching batch ${batchCount}...`);

        const batch = await getActiveCustomers(BATCH_SIZE, lastEvaluatedKey);

        // Combine results
        
        tmpResult = tmpResult !== undefined 
          ? [...tmpResult, ...batch.items] 
          : [...batch.items];

        lastEvaluatedKey = batch.lastEvaluatedKey;

        // Update UI immediately with current batch
        const sortedResults = [...tmpResult].sort(sortByPropertyInAscending("BodStatus")).sort((a, b) => {
          if (a.BodStatus === b.BodStatus) {
            return sortByPropertyInAscending("CustomerCode")(a, b);
          }
          return 0;
        });

        setFilteredResult(sortedResults);

        console.log(`Batch ${batchCount} loaded: ${batch.items.length} records (Total: ${tmpResult.length})`);

        // Small delay to prevent UI blocking
        await new Promise(resolve => setTimeout(resolve, 50));

      } while (lastEvaluatedKey);

    } else if (masterName === "Location Master") {
      if (arr.length > 1 && arr[1]) {
        tmpResult = await getActiveLocationForDivision(arr[1]);
      } else {
        tmpResult = await getAllActiveLocations();
      }
    } else if (masterName === "Item Master") {
      const itemResponse = await getItems();
      tmpResult = itemResponse.items || itemResponse;
    } else {
      tmpResult = dataMethod && (await dataMethod("Overseas"));
    }

    let result = tmpResult;
    if (masterName !== "Customer Master" && masterName !== "Location Master" && masterName !== "Item Master") {
      result = tmpResult?.reduce((accumulator, current) => {
        if (!accumulator.find((item) => item.Country === current.Country)) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);
    }
      setRowData(result);
      setFilteredResult(result);
      setData(result);
  };

  useEffect(() => {
    setParams(arr[1]);

    if (masterName === "Customer Master") {
      setColumnDefs([
        {
          field: "CustomerCode",
          headerName: "BP Code",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          tooltipField: "CustomerCode",
          width: 160,
        },
        {
          field: "CustomerName",
          headerName: "BP Name",
          tooltipField: "CustomerName",
          width: 200,
        },
        {
          field: "EmailId",
          headerName: "Email ID",
          tooltipField: "EmailId",
          width: 200,
        },
        {
          field: "Address",
          headerName: "Address",
          tooltipField: "Address",
          width: 200,
        },
      ]);
    } else if (masterName === "Location Master") {
      setColumnDefs([
        {
          field: "Division",
          headerName: "Division",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          tooltipField: "Division",
        },
        {
          field: "Location",
          headerName: "Location",
          tooltipField: "Location",
        }
      ]);
    } else if (masterName === "Item Master") {
      setColumnDefs([
        {
          field: "ItemCode",
          headerName: "Item Code",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          tooltipField: "ItemCode",
        },
        {
          field: "ItemDescription",
          headerName: "Item Description",
          tooltipField: "ItemDescription",
        }
      ]);
    }

    fetchData(parameters);
  }, [dataMethod]);

  const defaultColDef = {
    resizable: true,
    suppressMovable: true,
    filter: true,
    sortable: true,
    filterParams: {
      buttons: ["reset", "apply"],
      closeOnApply: true,
      defaultJoinOperator: "OR",
    },
  };

  const resetData = () => {
    gridRef?.current?.api?.forEachNode((node) => {
      node.setSelected(false);
    });
  }
  const assignData = () => {
    // let selectedRows = gridRef.current.api.getSelectedRows();
    // console.log("gridRef.current.api.getSelectedRows()",gridRef.current.api.getSelectedRows())

    // let selectedRowsCount = gridRef.current.api.getSelectedRows().length;
    console.log("selectedData", selectedData)
    let selectedRows = selectedData;
    let selectedRowsCount = selectedData.length;
    if (selectedRowsCount > 0) {
      props.setSelected({ name: props.masterName, result: selectedRows });
      props.onHide();
    } else
      setAlertMessage("Please select at least one checkbox");
  };

  const onRowSelected = (event) => {
    if (isProgrammaticSelect.current) return;
    const key = masterName === "Customer Master" ? "CustomerCode" : masterName === "Location Master" ? "Location" : masterName === "Item Master" ? "ItemCode" : "";
    const Index = selectedData.findIndex((element) => element[key] === event.node.data[key]);
    if (event.node.isSelected()) {
      if (Index === -1) {
        setSelectedData((data) => {
          const updated = [...data, event.node.data];
          selectedDataRef.current = updated;
          return updated;
        });
      }
    } else if (Index !== -1) {
      setSelectedData((prevData) => {
        const updated = prevData.filter((_, i) => i !== Index);
        selectedDataRef.current = updated;
        return updated;
      });
    }

  };

  const onGridReady = (value) => {
    setReady(!ready);
    gridRef.current.api.sizeColumnsToFit();
  };

  const handleGlobalSearch = async (text) => {
    let searchText = text.toLowerCase();
    if (searchText) {
      let result;
      if (masterName === "Customer Master") {
          result = rowData?.filter((item) =>
        (item.CustomerCode?.toLowerCase().indexOf(searchText) >= 0 ||
          item.CustomerName?.toLowerCase().indexOf(searchText) >= 0 ||
          item.EmailId?.toLowerCase().indexOf(searchText) >= 0 ||
          item.Address?.toLowerCase().indexOf(searchText) >= 0)
        );
      } else if (masterName === "Location Master") {
        result = rowData?.filter((item) =>
        (item.Division?.toLowerCase().indexOf(searchText) >= 0 ||
          item.Location?.toLowerCase().indexOf(searchText) >= 0)
        );
      } else if (masterName === "Item Master") {
        result = rowData?.filter((item) =>
        (item.ItemCode?.toLowerCase().indexOf(searchText) >= 0 ||
          item.ItemDescription?.toLowerCase().indexOf(searchText) >= 0)
        );
      }
      setFilteredResult(result);
    } else {
      setFilteredResult(rowData);
    }
  };

  useEffect(() => {
    if (props.selectedItems && rowData && rowData.length > 0) {
      const existingItems = [];
      const selectedValues = props.selectedItems.split(",").map(v => v.trim()).filter(v => v);

      selectedValues.forEach(value => {
        let item;
        if (masterName === "Customer Master") {
          item = rowData.find(row => row.CustomerCode === value);
        } else if (masterName === "Location Master") {
          item = rowData.find(row => row.Location === value);
        } else if (masterName === "Item Master") {
          item = rowData.find(row => row.ItemCode === value);
        }

        if (item) {
          existingItems.push(item);
        }
      });

      if (existingItems.length > 0) {
        setSelectedData(existingItems);
        selectedDataRef.current = existingItems;
      }
    }
  }, [rowData, props.selectedItems]);

  useEffect(() => {
    if (selectedDataRef.current.length > 0 && gridRef?.current?.api) {
      setTimeout(() => {
        isProgrammaticSelect.current = true;
        const key = masterName === "Customer Master" ? "CustomerCode" :
          masterName === "Location Master" ? "Location" :
            masterName === "Item Master" ? "ItemCode" : "";
        gridRef.current.api.forEachNode((node) => {
          const isSelected = selectedDataRef.current.some(item => item[key] === node.data[key]);
          node.setSelected(isSelected);
        });
        isProgrammaticSelect.current = false;
      }, 200);
    }
  }, [filteredResult, ready]);

  const resetAllFilter = () => {
    gridRef.current.api.setFilterModel(null);
  };

  function resetFilter(item) {
    let item1 = item.substring(0, item.indexOf(":") - 1);

    let col = gridRef.current.api.getFilterModel();
    for (const key of Object.keys(col)) {
      if (key === feildName(item1)) {
        delete col[key];
      }
    }
    gridRef.current.api.setFilterModel(col);
  }

  const headerName = (field) => {
    let name;
    switch (field) {
      case "CustomerCode":
        name = "BP Code";
        break;
      case "CustomerName":
        name = "BP Name";
        break;
      case "EmailId":
        name = "Email ID";
        break;
      case "Address":
        name = "Address";
        break;
      case "Division":
        name = "Division";
        break;
      case "Location":
        name = "Location";
        break;
      case "ItemCode":
        name = "Item Code";
        break;
      case "ItemDescription":
        name = "Item Description";
        break;
      case "Item Type":
        name = "ItemType";
        break;
      case "Product Class":
        name = "ProductClass";
        break;
      case "Commodity Code":
        name = "CommodityCodes";
        break;
      case "Logistic Company":
        name = "LogisticCompany";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const feildName = (header) => {
    let name;
    switch (header) {
      case "BP Code":
        name = "CustomerCode";
        break;
      case "BP Name":
        name = "CustomerName";
        break;
      case "Email ID":
        name = "EmailId";
        break;
      case "Address":
        name = "Address";
        break;
      case "Division":
        name = "Division";
        break;
      case "Location":
        name = "Location";
        break;
      case "Item Code":
        name = "ItemCode";
        break;
      case "Item Description":
        name = "ItemDescription";
        break;
      case "Item Type":
        name = "ItemType";
        break;
      case "Product Class":
        name = "ProductClass";
        break;
      case "Commodity Code":
        name = "CommodityCodes";
        break;
      case "Logistic Company":
        name = "LogisticCompany";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };
  const onFilterChanged = (param) => {
    let a = document.getElementById("filterDisplayPop");

    setFilteredCol([]);
    let col = param.api.getFilterModel();

    if (Object.keys(col).length === 0) {
      a.classList.add("d-none");
    } else {
      a.classList.remove("d-none");
      for (const key of Object.keys(col)) {
        let filter;
        if (col[key].condition1) {
          filter =
            headerName(key) +
            " : " +
            col[key].condition1.filter +
            ", " +
            col[key].condition2.filter;
        } else {
          filter = headerName(key) + " : " + col[key].filter;
        }
        setFilteredCol((prev) => {
          return [...prev, filter];
        });
      }
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setAlertMessage("");
  //   }, 10000);
  //   return () => clearTimeout(timer);
  // }, [alertMessage]);

  return (
    <>
      <Modal {...props} size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{props.masterName.split(":")[0]} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="global-search-container ">
            <Row><Col></Col>
              <Col>
                <GolbalSearch filterFunc={handleGlobalSearch} />
              </Col>
            </Row>
          </div>
          <div>
            <div
              className="d-none mb-3 d-flex"
              id="filterDisplayPop"
              style={{ gap: "10px" }}
            >
              {filteredCol &&
                filteredCol.map((item) => {
                  return (
                    <div className="filter-col pr-0 me-2">
                      <div>
                        <span className="ps-2 btn-text">{item}</span>
                      </div>
                      <div onClick={() => resetFilter(item)}>
                        <BsX size={32} />
                      </div>
                    </div>
                  );
                })}
              <Button
                variant="outline-primary"
                className="ms-2 lh-1 clear-all-btn"
                onClick={resetAllFilter}
              >
                Clear All
              </Button>
            </div>

            <div className="ag-theme-alpine popup"
            //style={{ height: "auto", width: "auto", overflow: "hidden", gridTemplateColumns: "auto auto auto", dispay: "grid" }}
            >
              <AgGridReact
                ref={gridRef}
                onRowSelected={onRowSelected}
                rowData={filteredResult}
                columnDefs={columnDefs}
                rowSelection={"multiple"}
                defaultColDef={defaultColDef}
                onGridReady={onGridReady}
                headerHeight={50}
                rowHeight={50}
                pagination={true}
                paginationPageSize={5}
                onFilterChanged={onFilterChanged}
                enableBrowserTooltips={true}
                domLayout="autoHeight"
                rowMultiSelectWithClick={true}
              ></AgGridReact>
            </div>

          </div>
        </Modal.Body>

        {alertMessage && (
          <Alert variant="light">
            {alertMessage}
          </Alert>
        )}

        <Modal.Footer className="">
          <Row style={{ width: "100%" }}>
            <Col> <Button
              size="sm"
              variant="outline-success"
              className="semiBoldToggleButton cancelBtn"
              onClick={resetData}
            >Reset </Button></Col>

            <Col >  <Button
              variant="success"
              type="submit"
              className="btn-add-color semiBoldToggleButton rightAlignedButton"
              onClick={assignData}
            >
              Add
            </Button>

            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MultiValuePopUp;
